import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/observatorygrouporder/';
    const pathsList = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'governanceroom/observatorygrouporder/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/observatorygrouporder/delete`
    }

    const list = {
        labelTitle: 'Lista de Ordens de Grupos do Observatório',
        labelTitleButtonAdd: 'Incluir nova ordem',
        fieldsShowOnDelete: ['observatory'],
        filter: profileFilter,
        canDelete: true,
        columns: [
            {
                name: 'observatory',
                label: 'Observatório'
            }
        ],
        ...pathsList
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
